(function () {
  if (customElements.get('cr-sphere-names')) return;
  class SphereNames extends HTMLElement {
    #values = [];
    #controller;
    #form;
    #quantity;
    #line;
    #properties = {};
    #editing = false;
    #busy = false;
    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      this.#form = this.closest('form');
      this.#quantity = this.#form?.querySelector('[name=quantity]');
      if (!this.#form || !this.#quantity) return;
      this.#form.classList.add('cr-names-ready');
      const signal = this.#controller.signal;
      for (const event of ['change','quantity-selector:update']) this.#form.addEventListener(event, e => { if(e.target === this.#quantity) this.render(); }, {signal});
      this.addEventListener('input', e => { if(e.target.matches('[data-cr-name-input]')) { e.target.setCustomValidity(''); this.read(); this.save(); } }, {signal});
      this.querySelector('[data-cr-apply-names]')?.addEventListener('click', () => this.applyList(), {signal});
      this.#form.addEventListener('submit', e => this.submit(e), {capture:true,signal});
      this.#line = new URLSearchParams(location.search).get('cr_edit_line');
      if (this.#line) this.loadLine();
      else this.restore();
    }
    disconnectedCallback() { this.#controller?.abort(); }
    get count() { return Math.max(1,Math.floor(Number(this.#quantity?.value)||1)) * Number(this.dataset.perUnit); }
    get storageKey() { return 'crealis-sphere-names-'+this.dataset.productId+'-'+(this.#line || 'new'); }
    read() { this.querySelectorAll('[data-cr-name-input]').forEach((input,index)=>{this.#values[index]=input.value;}); }
    render(readCurrent = true) {
      if(readCurrent)this.read();
      const fields=this.querySelector('[data-cr-name-fields]');
      const template=this.querySelector('[data-cr-name-template]');
      if (!fields || !template || !Number.isSafeInteger(this.count) || this.count > 1000) return;
      const fragment=document.createDocumentFragment();
      for(let i=0;i<this.count;i++) {
        const field=template.content.cloneNode(true);
        const input=field.querySelector('input');
        const label=field.querySelector('label');
        const id=this.dataset.formId+'-sphere-'+(i+1);
        input.id=id;input.name='properties[Nombre '+(i+1)+']';input.value=this.#values[i]||'';
        label.htmlFor=id;label.textContent=this.dataset.fieldLabel.replace('{number}',String(i+1));
        fragment.appendChild(field);
      }
      fields.replaceChildren(fragment);
      const total=this.querySelector('[data-cr-names-total]');
      if(total)total.textContent=this.dataset.totalLabel.replace('{count}',String(this.count));
      this.save();
    }
    restore() {
      try {
        const draft=JSON.parse(sessionStorage.getItem(this.storageKey)||'null');
        if(draft && Date.now()-draft.ts<7200000) { this.#values=draft.values||[];this.#quantity.value=String(draft.quantity||1); }
      } catch(error) {}
      this.render(false);
    }
    save() { try {sessionStorage.setItem(this.storageKey,JSON.stringify({quantity:this.#quantity.value,values:this.#values,ts:Date.now()}));}catch(error){} }
    applyList() {
      const names=(this.querySelector('[data-cr-name-list]')?.value||'').split(/\r?\n/).map(n=>n.trim()).filter(Boolean);
      if(names.length!==this.count) {this.error(this.dataset.mismatch.replace('{count}',String(this.count)));return;}
      this.#values=names;
      this.querySelectorAll('[data-cr-name-input]').forEach((input,i)=>{input.value=names[i];input.setCustomValidity('');});
      this.error('');this.save();
    }
    error(message) { const node=this.querySelector('[data-cr-names-error]');if(node){node.textContent=message;node.hidden=!message;} }
    async loadLine() {
      this.#editing=true;this.#busy=true;
      try {
        const response=await fetch(this.dataset.cartUrl+'.js',{signal:this.#controller.signal});
        if(!response.ok)throw Error('Cart unavailable');
        const cart=await response.json();
        const item=cart.items.find(item=>item.key===this.#line && String(item.product_id)===this.dataset.productId);
        if(!item)throw Error('Line missing');
        this.#properties=item.properties||{};
        this.#quantity.value=String(item.quantity);
        this.#values=Array.from({length:item.quantity*Number(this.dataset.perUnit)},(_,i)=>this.#properties['Nombre '+(i+1)]||'');
        this.render(false);
        const text=this.#form.querySelector('.add-to-cart-text__content');
        if(text)text.textContent=this.dataset.update;
        this.#busy=false;
      } catch(error) {this.error(this.dataset.failed);}
    }
    submit(event) {
      this.read();
      const inputs=[...this.querySelectorAll('[data-cr-name-input]')];
      const missing=inputs.find(input=>!input.value.trim());
      if(this.#busy || inputs.length!==this.count || missing) {
        event.preventDefault();event.stopImmediatePropagation();
        if(missing){missing.setCustomValidity(this.dataset.missing);missing.reportValidity();}
        return;
      }
      inputs.forEach(input=>{input.value=input.value.trim();});
      this.save();
      if(!this.#editing)return;
      event.preventDefault();event.stopImmediatePropagation();
      this.updateLine();
    }
    async updateLine() {
      this.#busy=true;
      const button=this.#form.querySelector('button[type=submit]');
      if(button)button.disabled=true;
      const properties={...this.#properties};
      for(const key of Object.keys(properties))if(/^Nombre \d+$/.test(key))delete properties[key];
      this.querySelectorAll('[data-cr-name-input]').forEach((input,index)=>{properties['Nombre '+(index+1)]=input.value.trim();});
      properties._crealis_names_per_unit=this.dataset.perUnit;
      try {
        const response=await fetch(this.dataset.cartUrl+'/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:this.#line,quantity:Number(this.#quantity.value),properties}),signal:this.#controller.signal});
        if(!response.ok)throw Error('Update failed');
        sessionStorage.removeItem(this.storageKey);
        location.assign(this.dataset.cartUrl);
      } catch(error) {this.#busy=false;this.error(this.dataset.failed);if(button)button.disabled=false;}
    }
  }
  customElements.define('cr-sphere-names',SphereNames);
})();
